<template>
  <div>
    <a-modal v-model="modalVisible" :destroy-on-close="true" width="850px" :title="`业务需求(${title})`" :footer="false" @cancel="close">
      <a-table :pagination="pagination" :columns="columns" size="middle" :data-source="tableData" row-key="id" :loading="loading" @change="handleTableChange">
        <div slot="idSlots" slot-scope="text, record">
          {{ `BR-${record.id}` }}
        </div>
        <div slot="titleSlots" slot-scope="text, record">
          <a class="custom-link" :href="link(record)" target="_blank">{{ record.title }}</a>
        </div>
        <span slot="status" slot-scope="text, record">
          <StatusTag :status="record.status" />
        </span>
        <span slot="creator" slot-scope="text, record">
          {{ getUserName(record.creator) }}
        </span>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import { queryBusinessRequirement } from '@/api/business/requirement';
import StatusTag from '@/pages/business/requirement/components/StatusTag';
const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 70,
    scopedSlots: { customRender: 'idSlots' }
    // customRender: (_, record) => 'BR-' + record.id
  },
  {
    title: '需求标题',
    dataIndex: 'title',
    key: 'title',
    width: 200,
    scopedSlots: { customRender: 'titleSlots' }
  },
  {
    width: 120,
    ellipsis: true,
    title: '状态',
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '创建人',
    dataIndex: 'creator',
    key: 'creator',
    align: 'center',
    width: 100,
    scopedSlots: { customRender: 'creator' }
  },
  {
    title: '创建时间',
    dataIndex: 'createdTime',
    key: 'createdTime',
    align: 'center',
    width: 170
  }
];

export default {
  components: { StatusTag },
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      modalVisible: false,
      loading: false,
      tableData: [],
      filterForm: {
        page_size: 10,
        page_number: 1,
        statusList: []
      },
      title: '',
      columns,
      pagination: {
        size: 'large',
        total: 0,
        current: 1,
        pageSize: 10, // 每页中显示20条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      }
    };
  },
  computed: {
    link() {
      return record => {
        return this.$router.resolve({
          name: 'page:business:requirement:detail',
          params: { id: record.id }
        }).href;
      };
    }
  },
  watch: {},
  methods: {
    close() {
      this.modalVisible = false;
      this.filterForm = {
        page_size: 10,
        page_number: 1,
        statusList: [],
        target: []
      };
      this.pagination = {
        size: 'large',
        total: 0,
        current: 1,
        pageSize: 10, // 每页中显示20条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      };
    },
    open(title, filter) {
      this.title = title;
      this.filterForm.statusList = filter ? filter.statusList || [] : [];
      this.filterForm.target = filter ? filter.target || [] : [];
      this.filterForm.ids = filter ? filter.ids || [] : [];
      this.filterForm.isInvalid = filter ? filter.isInvalid || false : false;
      this.filterForm.businessDepartment = filter ? filter.businessDepartment || [] : [];
      this.modalVisible = true;
      this.getDataList();
    },
    getUserName(userId) {
      const user = this.$store.state.allUsers.find(item => item.id === userId);
      if (user) {
        return user.nickname || '--';
      } else {
        return '--';
      }
    },
    onOk() {
      this.$emit('ok');
    },

    handleTableChange(pagination, _, sorter) {
      this.pagination = pagination;
      this.filterForm.page_size = pagination.pageSize;
      this.filterForm.page_number = pagination.current;
      this.filterForm.sort_field = sorter.field;
      this.filterForm.sort = sorter.order === 'ascend' ? 'asc' : 'desc';
      this.getDataList();
    },
    getDataList() {
      this.loading = true;
      const devFilterStatus = [134, 135, 136, 137, 138, 139];
      if (this.type === 'dev') {
        this.filterForm.statusList = devFilterStatus;
      }
      queryBusinessRequirement({ ...this.filterForm })
        .then(res => {
          this.tableData = res.data.items;
          this.pagination.total = res.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>
